module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/crm/crm.html
// module id = 409
// module chunks = 0